import React, { useState, useEffect } from "react";
import {
  Container,
  CircularProgress,
  Typography,
  IconButton,
  Grid,
  Box,
  Link,
  Tooltip,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import { ROLE } from "../utils/commonConstant";
import { DataGrid } from "@mui/x-data-grid";
import "../App.css";
import { fetchAllClients } from "../utils/formUtils";
import dayjs from "dayjs";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import ContractSignDocumentPopup from "./../ModelPopup/ContractSignDocument";

const ClientPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { clientId } = useParams();
  const role = localStorage.getItem("Role");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    actions: role === ROLE.ADMIN ? true : false,
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  // Define initial sort model
  const sortModel = [
    {
      field: "ContractToReview", // Sort by the FileName column
      sort: "desc", // 'asc' for ascending order, 'desc' for descending
    },
  ];
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      headerClassName: "bold-header",
    },
    {
      field: "Name",
      headerName: "Client Name",
      width: 300,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => {
        const href = `/${params.row.Id}`;
        return (
          <Link
            href={href}
            underline="hover"
            sx={{
              color: "text.primary",
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "ContractToReview",
      headerName: "Review Required",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => (
        <IconButton>
          {params.row.ContractToReview ? (
            <CheckIcon color="success" />
          ) : (
            <CloseIcon color="error" />
          )}
        </IconButton>
      ),
    },
    {
      field: "AgreementEndDate",
      headerName: "Renewal Date",
      width: 300,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => {
        if (params.value) {
          return dayjs(params.value).format("DD/MM/YYYY");
        }
        return "NA";
      },
    },
    {
      field: "NumSubContractors",
      headerName: "Number of Subbies",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      sortable: false,
      align: "center",
      headerClassName: "bold-header",
      headerAlign: "center",
      renderCell: (params) => (
        <Box>
          <Tooltip title="Contract Sign Documents" arrow>
            <IconButton
              color="success"
              aria-label="View Sign Documents"
              onClick={() => handleContractSignDocument(params.row)}
            >
              <FileOpenIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];
  const handleContractSignDocument = (row) => {
    setSelectedClient(row);
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedClient(null);
  };
  const fetchData = async () => {
    try {
      const result = await fetchAllClients();
      const dataWithid = result.map((data) => ({
        id: data.Id,
        ...data,
      }));
      setData(dataWithid);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [clientId]);

  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography color="error">
          Error fetching data: {error.message}
        </Typography>
      </Container>
    );
  }

  return (
    <>
      <Box sx={{ padding: 2 }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ marginBottom: 2 }}
        >
          <Grid item xs={12} sm="auto" display="flex" justifyContent="center">
            <Link href={`/`}>
              <img
                src="https://portal.hardhats.co.uk/img/Hardhats-Logo.png"
                alt="HardHats Logo"
                style={{ width: "80px", marginRight: "20px" }}
              />
            </Link>
          </Grid>
          <Grid item xs={12} sm="auto">
            <h2 style={{ textAlign: "center" }}>Contract for Services</h2>
          </Grid>
        </Grid>
        <Container>
          <Grid
            container
            //justifyContent="space-between"
            justifyContent="flex-end"
            alignItems="center"
            mb={2}
            spacing={2}
          >
            {/* <Grid item>
              <Button variant="contained" color="primary" onClick={handleBack}>
                Back
              </Button>
            </Grid> */}
            {/* <Grid item justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreate}
              >
                Create New Document
              </Button>
            </Grid> */}
            {/* <Grid item justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={handleTemplate}
              >
                Template
              </Button>
            </Grid> */}
          </Grid>
          <DataGrid
            rows={data}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10, 50, 100]}
            disableSelectionOnClick // Disable row selection
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            sortModel={sortModel} // Set initial sort model
          />
        </Container>
      </Box>
      {selectedClient && (
        <ContractSignDocumentPopup
          open={dialogOpen}
          onClose={handleCloseDialog}
          clientId={selectedClient.id}
        />
      )}
    </>
  );
};

export default ClientPage;
